import { Editor, Range } from 'slate';

import { MentionData } from '../mentions/MentionsMenu';
import { ReactEditorWithEntities } from './useSlate';

export const withMentions = (
  setMentionData: (buildNewMentionData: (existing: MentionData) => MentionData) => void,
  setQuery: (q: string) => void
) => (editor: ReactEditorWithEntities): ReactEditorWithEntities => {
  const { isInline, isVoid, onChange } = editor;

  editor.isVoid = (element): boolean => {
    return element.type === 'mention' ? true : isVoid(element);
  };

  editor.isInline = (element): boolean => {
    return element.type === 'mention' ? true : isInline(element);
  };

  editor.onChange = (): void => {
    onChange();

    const { selection } = editor;
    let updatedMentionData: Partial<MentionData> = { target: undefined };
    // inspired by https://www.slatejs.org/examples/mentions
    if (selection && Range.isCollapsed(selection)) {
      const [start] = Range.edges(selection);
      const wordBefore = Editor.before(editor, start, { unit: 'word' });
      const before = wordBefore && Editor.before(editor, wordBefore);
      const beforeRange = before && Editor.range(editor, before, start);
      const beforeText = beforeRange && Editor.string(editor, beforeRange);
      const beforeMatch = beforeText && beforeText.match(/^@(\w+)$/);
      const after = Editor.after(editor, start);
      const afterRange = Editor.range(editor, start, after);
      const afterText = Editor.string(editor, afterRange);
      const afterMatch = afterText.match(/^(\s|$)/);
      if (beforeMatch && afterMatch) {
        updatedMentionData = { target: beforeRange, index: 0 };
        setQuery(beforeMatch[1]);
      } else {
        // Check if immediately preceding character is an @
        const charBefore = Editor.before(editor, start, { unit: 'character' });
        const beforeRange = charBefore && Editor.range(editor, charBefore, start);
        const beforeText = beforeRange && Editor.string(editor, beforeRange);
        if (beforeText === '@') {
          updatedMentionData = { target: beforeRange, index: 0 };
          setQuery('');
        }
      }
    }

    setMentionData((mentionData) => ({ ...mentionData, ...updatedMentionData }));
  };

  return editor;
};
